export function retry<T>(fn: () => Promise<T>, exceptions: string[] = [], retries = 3): Promise<T> {
	return new Promise((resolve, reject) => {
		const attempt = async () => {
			try {
				const result = await fn()
				resolve(result)
			} catch (error) {
				retries--
				if (retries === 0 || (error instanceof Error && exceptions.includes(error.name))) {
					reject(error)
					return
				}
				setTimeout(attempt, 50)
			}
		}
		attempt()
	})
}
